import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarLibroMedioImpugnacionParams, LibroMedioImpugnacionResponse, defaultBuscarLibroMedioImpugnacionResponse, DescargarInformacionParams, GuardarObservaciones } from '../../interfaces/libros-electronicos/LibroMedioImpugnacionInterface';

export const ObtenerLibroMedioImpugnacion = ( params: BuscarLibroMedioImpugnacionParams ) => {

    return new Promise<LibroMedioImpugnacionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post('/Api/LibroMedioImpugnacion/ObtenerLibroMedioImpugnacion', params, token)
            .then(({ data }: { data: LibroMedioImpugnacionResponse }) => {
                resolve(data);
            })
            .catch( () => {
                resolve({ ...defaultBuscarLibroMedioImpugnacionResponse });
            });

        }

    });

}

export const GuardarObservacionesLibroMedioImpugnacion = ( params: GuardarObservaciones ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/LibroMedioImpugnacion/GuardarObservaciones', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const DescargarLibroMedioImpugnacion = ( params: DescargarInformacionParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientFileToken.post('/Api/LibroMedioImpugnacion/DescargarInformacion', params, token)
            .then( ({ data } : { data : Blob } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
